/**
 * MAX-3948: display labels for the Lead Activity Emails table, keyed on designPageName.
 *
 * Keyed on designPageName rather than shortDesc because that is what the backend joins on and
 * what ContactMessageType carries. Rows the API returns that are not listed here fall back to
 * their shortDesc, so a catalog addition shows up with its raw name instead of blanking.
 *
 * Angelica confirmed two things that shaped this list (2026-09-01):
 *  - The two Property Organizer rows collapse into one. They are distinct trigger events but
 *    share a single EmailRouting config keyed only by client, so offering them as separately
 *    editable rows implied control that does not exist.
 *  - "Signs up for saved search alerts" is the one-time signup notification, not the recurring
 *    alert emails; those belong to the Email Copies toggle on Notifications > Emails.
 */
export const leadActivityLabels: { [designPageName: string]: string } = {
	ContactEmail: "Submits contact form",
	MoreInfoRequest: "Requests more info",
	ScheduleShowingEmail: "Schedules a tour",
	PropertyOrganizerSignUpToClient: "Signs up for Property Organizer",
	// Verified against the live /email-routing-rules payload, not inferred: the constant is
	// SubscriberAssignedToAgent (shortDesc "Subscriber Assigned to Agent"). An earlier guess of
	// "AgentAssignment" silently dropped this row from the table.
	SubscriberAssignedToAgent: "Assigned to agent",
	ValuationEmail: "Requests home valuation / CMA",
	RegisteredUserWelcome: "Registers on website",
	EmailUpdateSignUp: "Signs up for saved search alerts",
};

/**
 * The table is an allowlist built from `displayOrder` below, so any EmailMaster row not listed
 * there is hidden automatically — including the ones this ticket removes ("Disclosure Reports
 * Request Summary", "Inactive Subscribers Summary", the lead-facing Property Organizer
 * confirmation, and the Existing Lead variant collapsed in per Angelica on 2026-09-01).
 *
 * All of those remain live notifications; the ticket removes them from this table only, it does
 * not retire the underlying sends. Deliberately not enumerated as constants here — a previous
 * revision listed guessed designPageName strings, which is the same mistake that silently
 * dropped the "Assigned to agent" row.
 */
export const displayOrder: string[] = [
	"ContactEmail",
	"MoreInfoRequest",
	"ScheduleShowingEmail",
	"PropertyOrganizerSignUpToClient",
	"SubscriberAssignedToAgent",
	"ValuationEmail",
	"RegisteredUserWelcome",
	"EmailUpdateSignUp",
];
